<div class="page-layout">
  <app-toast></app-toast>

  <app-sidebar></app-sidebar>

  <div class="main-area">
    <app-navbar
      pageTitle="Manage Batches"
      pageSubtitle="Create and manage document batches for AI analysis."
    ></app-navbar>

    <div class="content">
      <!-- Reviews waiting: new text that changes stored content stays out of search and chat until decided. -->
      <div class="review-banner" *ngIf="pendingReviews() > 0" role="button" tabindex="0"
           (click)="openVersionReview()" (keydown.enter)="openVersionReview()">
        <span class="review-banner-icon" aria-hidden="true">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9"/>
            <path d="M10.3 21a1.94 1.94 0 0 0 3.4 0"/>
          </svg>
          <span class="review-banner-dot"></span>
        </span>
        <div class="review-banner-text">
          <strong>{{ pendingReviews() }} {{ pendingReviews() === 1 ? 'change is' : 'changes are' }} waiting for your review</strong>
          <span>New files update content that's already stored. The new text stays out of search and chat until you decide.</span>
        </div>
        <span class="review-banner-btn">
          Review now
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="9 18 15 12 9 6"/></svg>
        </span>
      </div>

      <div class="toolbar">
        <div class="filters">
          <button class="filter-btn" [class.active]="activeFilter() === null" (click)="loadBatches(null)">
            All ({{ allCount() }})
          </button>
          <button class="filter-btn" [class.active]="activeFilter() === 'Completed'" (click)="loadBatches('Completed')">
            Completed ({{ completedCount() }})
          </button>
          <button class="filter-btn" [class.active]="activeFilter() === 'Processing'" (click)="loadBatches('Processing')">
            Processing ({{ processingCount() }})
          </button>
          <button class="filter-btn" [class.active]="activeFilter() === 'Preparing'" (click)="loadBatches('Preparing')">
            Preparing ({{ preparingCount() }})
          </button>
          <button class="filter-btn" [class.active]="activeFilter() === 'Failed'" (click)="loadBatches('Failed')">
            Failed ({{ failedCount() }})
          </button>
          <button class="filter-btn" [class.active]="activeFilter() === 'Draft'" (click)="loadBatches('Draft')">
            Draft ({{ draftCount() }})
          </button>

          <span class="batch-count">{{ totalItems() }} batches</span>
        </div>

        <div class="toolbar-actions">
          <div class="search-box">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#68728F" stroke-width="2">
              <circle cx="11" cy="11" r="8"/>
              <line x1="21" y1="21" x2="16.65" y2="16.65"/>
            </svg>
            <input type="text" placeholder="Search batches..." [(ngModel)]="searchQuery" (input)="onSearch($event)" />
          </div>

          <app-button [variant]="hasSelection ? 'accent' : 'muted'" [disabled]="!hasSelection || isIngesting()" (clicked)="onIngestSelected()">
            {{ isIngesting() ? 'Ingesting...' : 'Ingest Batch' }}
          </app-button>
          <app-button variant="primary" (clicked)="openCreateBatchModal()">Create Batch</app-button>
        </div>
      </div>

      <div class="batch-grid" *ngIf="!isLoading()">
        <div class="batch-card" *ngFor="let batch of batches()" (click)="router.navigate(['/batch-details', batch.id])" style="cursor:pointer">
         <div class="card-top">
  <div class="card-left">
    <button class="checkbox-btn" [class.checked]="isSelected(batch.id)" (click)="toggleSelect(batch.id, $event)">
      <svg *ngIf="isSelected(batch.id)" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#FFFFFF" stroke-width="3">
        <polyline points="20 6 9 17 4 12"/>
      </svg>
    </button>
    <div class="card-icon">
      <svg *ngIf="batch.sourceType === 'Mailbox'" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#0A66C2" stroke-width="2">
        <rect x="2" y="4" width="20" height="16" rx="2"/>
        <path d="M2 6l10 7 10-7"/>
      </svg>
      <svg *ngIf="batch.sourceType !== 'Mailbox'" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#A855F7" stroke-width="2">
        <path d="M12 2L2 7l10 5 10-5-10-5z"/>
        <path d="M2 17l10 5 10-5"/>
        <path d="M2 12l10 5 10-5"/>
      </svg>
    </div>
    <h3 class="batch-name">{{ batch.name }}</h3>
  </div>
  <span class="status-badge" [ngClass]="statusClass(batch.status)">{{ batch.status }}</span>
</div>

<p class="batch-description">{{ batch.description || 'No description provided.' }}</p>
          <div class="card-footer">
            <span class="batch-date">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#68728F" stroke-width="2">
                <rect x="3" y="4" width="18" height="18" rx="2"/>
                <line x1="16" y1="2" x2="16" y2="6"/>
                <line x1="8" y1="2" x2="8" y2="6"/>
                <line x1="3" y1="10" x2="21" y2="10"/>
              </svg>
              {{ formatDate(batch.createdAt) }}
            </span>
            <button class="review-pill" *ngIf="pendingFor(batch.id) as n" (click)="openVersionReview($event)"
                    [attr.aria-label]="n + ' changes in this batch waiting for review'">
              <span class="review-pill-dot"></span>
              {{ n }} to review
            </button>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#68728F" stroke-width="2">
              <polyline points="9 18 15 12 9 6"/>
            </svg>
          </div>
        </div>
      </div>

      <div class="empty-batches" *ngIf="!isLoading() && batches().length === 0">
        <p>No batches found.</p>
      </div>

      <div class="pagination" *ngIf="!isLoading() && batches().length > 0">
        <app-button variant="secondary" size="sm" [disabled]="currentPage() === 1" (clicked)="prevPage()">Previous</app-button>
        <span class="page-info">{{ currentPage() }} of {{ totalPages }}</span>
        <app-button variant="secondary" size="sm" [disabled]="currentPage() === totalPages" (clicked)="nextPage()">Next</app-button>
      </div>
    </div>
  </div>

  <app-create-batch-modal
    *ngIf="showCreateBatchModal()"
    [isSaving]="isCreatingBatch()"
    (close)="closeCreateBatchModal()"
    (save)="onSaveBatch($event)"
  ></app-create-batch-modal>

  <app-batch-created-modal
    *ngIf="showBatchCreatedModal()"
    (cancel)="closeBatchCreatedModal()"
    (createMore)="onCreateMoreBatch()"
  ></app-batch-created-modal>

</div>